import React from 'react';
import { observer } from 'mobx-react';

import { Footer } from '../../../common/footer';
import { HomeNavbar } from '../../../common/home-navbar';
import { InformationMenu } from '../information-menu';
import { ScreenStore } from '../../../stores/ScreenStore';
import { MainSectionContent } from './main-section-content';
import { constants } from '../../../config';
import { routeNaming, AppLink } from '../../../routes';
import { FAQStore } from './stores/FAQStore';
import { Spinner } from '../../../common/spinner';
import styles from './Help.css';
import { SEO } from '../../../common/seo';

class Help extends React.Component {
  componentDidMount() {
    FAQStore.getFaqInfo();
  }

  componentWillUnmount() {
    FAQStore.clearError();
  }

  render() {
    const dataLoaded = FAQStore.faqInfo !== null;
    const showMobileVersion = ScreenStore.screenWidth <= constants.breakpoints.mobileThreshold;
    return (
      <div className={styles.container}>
        <SEO
          title="Ayuda"
          description="Accede a toda la información relevante sobre Carlos Gutiérrez S.A, nuestros servicios, políticas y cómo podemos ayudarte. Encuentra detalles sobre nuestros productos, condiciones de uso, privacidad, envíos y más. Estamos comprometidos a ofrecerte la mejor experiencia, brindándote transparencia y claridad en todos nuestros procesos. Si tienes preguntas o dudas, esta sección es tu recurso principal para obtener respuestas. Descubre todo lo que necesitas saber y disfruta de una experiencia de compra segura y satisfactoria con nosotros"
          type="website"
        />
        <HomeNavbar />
        <div className={styles.mainWrapper}>
          <div className={styles.mainContent}>
            {showMobileVersion ?
              <p className={styles.breadcrumb}>
                <AppLink
                  className={styles.breadcrumb}
                  routeName={routeNaming.INFORMATION_MENU_MOBILE}
                >
                  Información
                </AppLink>
                <span> &gt; Ayuda</span>
              </p>
              : <InformationMenu indexSelectedItem={0} />}
            <div className={styles.bodyContainer}>
              <div className={styles.titleContainer}>
                <h1 className={styles.mainTitle}> Ayuda </h1>
              </div>
              <div className={styles.contentContainer}>
                <p>
                  Algunas de nuestras preguntas más frecuentes realizadas por nuestros
                  usuarios sobre nuestro proceso de compra, formas de pago, envíos a
                  todo el país y service de productos Panavox.
                </p>
                <div className={styles.contentSection}>
                  {
                    dataLoaded
                    ? FAQStore.faqInfo.map(element => (
                      <MainSectionContent
                        key={element.title}
                        title={element.title}
                        mainSectionInfo={element.sections}
                      />
                      ))
                    : <Spinner className={styles.spinner} />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const ObservedHelp = observer(Help);

export { ObservedHelp as Help };



// WEBPACK FOOTER //
// ./src/pages/information/help/Help.jsx